import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ReactNode } from 'react';

export const SidebarWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div
      className={`flex flex-col relative h-screen border-r border-component-border`}
      style={{ width: CONSTANTS__client.SIDEBAR_LEFT_WIDTH, minWidth: CONSTANTS__client.SIDEBAR_LEFT_WIDTH }}
    >
      <div className="flex-grow overflow-hidden bg-component">{children}</div>
    </div>
  );
};
